var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.85 16.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cbd0d4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M863,85.07h-3.74c-1.4,0-2.55.86-2.55,1.92v3.66a2.1,2.1,0,0,0,1.86,1.85v4.11h1.26v-5h-.58c-.71,0-1.29-.43-1.29-1V87c0-.54.58-1,1.29-1H863c.71,0,1.29.43,1.29,1v3.66c0,.54-.58,1-1.29,1h-.58v5h1.27V92.5a2.1,2.1,0,0,0,1.86-1.85V87c0-1.06-1.15-1.92-2.55-1.92",
    transform: "translate(-856.73 -79.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M861.15,83.14c-.94,0-1.71-.57-1.71-1.28s.77-1.29,1.71-1.29,1.71.58,1.71,1.29-.77,1.28-1.71,1.28m0-3.51c-1.64,0-3,1-3,2.23s1.33,2.23,3,2.23,3-1,3-2.23-1.33-2.23-3-2.23",
    transform: "translate(-856.73 -79.63)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.556e6c7d.svg";
export { ForwardRef as ReactComponent };